<sbnb-apps-detail-page
  vendorCode="hudson-creative"
  name="Hudson Creative Studio"
  logoTile="/assets/images/apps/hudson-creative.png"
  builtBy="Hudson Creative Studio"
  builtByLink="https://hudsoncreativestudio.com/"
  [categories]="['Direct bookings']"
  [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead, AppPermission.calendarRead]"
  email="helpdesk@hudsoncreativestudio.com"
  [helpArticles]="[
    {
      id: '9975313',
      title: 'Connect Hospitable with Hudson Creative Studio to create an integrated direct booking site'
    }
  ]">
  <div style="position: relative; padding-bottom: 56.25%; height: 0">
    <iframe
      src="https://www.youtube.com/embed/Y4LEGdNqjEY"
      frameborder="0"
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
  </div>
  <ng-container description>
    <p>
      Hudson Creative Studio specializes in building custom WordPress websites for vacation rental businesses,
      seamlessly integrating with Hospitable. Their approach combines stunning design with powerful functionality to
      drive direct bookings and revenue, all while ensuring you retain full ownership of your website.
    </p>

    <p class="font-bold">Key Features and Benefits:</p>
    <ul class="mt-0">
      <li>Bespoke WordPress design tailored to your brand</li>
      <li class="mt-2">Mobile-responsive design for all devices</li>
      <li class="mt-2">Seamless integration with Hospitable API</li>
      <li class="mt-2">Real-time synchronization of rates, availability, and reviews</li>
      <li class="mt-2">Modern and secure booking engine with AI features</li>
      <li class="mt-2">Customizable property collections and advanced filtering</li>
      <li class="mt-2">Full website ownership and control</li>
    </ul>

    <p>Get a unique, high-performing website that truly represents your brand and maximizes your bottom line.</p>
  </ng-container>
</sbnb-apps-detail-page>
